import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {WinConfigUtil} from "../../utils/WinConfigUtil";
import {SymbolUtils} from "../../utils/SymbolUtils";
import {BasicSymbol, SymbolStates} from "../../reels/symbols/BasicSymbol";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";


export class InitialWin implements SimplePresentation {

    name: string = "InitialWin";

    constructor() {
    }

    shouldRun(): boolean {
        XwaysHoarder2.waysCounter.showCurrentWays();
        return XwaysHoarder2.model.winRatio > 0 && XwaysHoarder2.model.gameData.betWayWins.length > 0;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish()
            }
        });
        const belowStake = XwaysHoarder2.isWinBelowStake();


        tl.add([this.getInitialWin(XwaysHoarder2.model.isBigWin && !XwaysHoarder2.model.gameData.brokeTheBank)]);
        tl.add([
            this.getIndividualWinHighlights(),
            () => {
                const rand:number = WinConfigUtil.randomIntFromInterval(0, 2);
                const  soundName: string = XwaysHoarder2Sound.BETLINE_SWEEPS[rand];
                XwaysHoarder2Sound.playTrack(soundName);
            }
        ], "<");

    }

    private playGroupWin(betWayWin: boolean[][], index: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        if (index) {
            tl.add(() => {
                //XwaysHoarder2.soundPlayer.playWinHighlightToggleSound();
            }, 0);
        }
        for (let reelId: number = 0; reelId < XwaysHoarder2.model.evaluatedArea.length; reelId++) {
            for (let rowId: number = 0; rowId < XwaysHoarder2.model.evaluatedArea[reelId].length; rowId++) {
                const symbol: BasicSymbol = <BasicSymbol>XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(rowId).positionable,
                    symId: string = XwaysHoarder2.model.evaluatedArea[reelId][rowId],
                    symbolName: string = XwaysHoarder2.model.data.reels[reelId][rowId]
                if (betWayWin[reelId][rowId] || symId.indexOf("SW") > -1 || (symId === "W")) {
                    //tl.add(StockholmSyndrome.winView.winAnim(reelId, rowId, "regularSymbolWin"), 0);
                    if (symId === "W") {
                        //tl.add(StockholmSyndrome.winView.playHappyWinAnimation(<StockholmSyndromeSymbol>symbol, symbolName), 0);
                    } else {
                        //tl.add(XwaysHoarder2.winView.playWinAnimation(<StockholmSyndromeSymbol>symbol, symbolName), 0);
                    }
                } else {

                }
            }
        }
        return tl;
    }

    private getIndividualWinHighlights(): gsap.core.Timeline {
        const winTl: gsap.core.Timeline = gsap.timeline(),
            gameData = XwaysHoarder2.model.data;
        let delay: number = 0.1;

        for (let winGroup: number = 0; winGroup < gameData.betWayWins.length; winGroup++) {
            const groupWin: IBetWayWinData = gameData.betWayWins[winGroup];
            const allWinPositions: boolean[][] = XwaysHoarder2.model.calculateGroupWinPositions(groupWin);
            let offset: number = winGroup - 0.7;
            winTl.add(this.playGroupWin(allWinPositions, winGroup), delay * offset);
            const winNumPlayPosition: number[] = XwaysHoarder2.winView.findLastNoWildSymbolPosition(groupWin);
            groupWin.reelWinPositions.forEach((reelWin: boolean[], reelId: number) => {
                reelWin.forEach((winPos: boolean, rowId: number) => {
                    if (winPos) {
                        if (reelId === winNumPlayPosition[0] && rowId === winNumPlayPosition[1]) {
                            if(!XwaysHoarder2.model.gameData.brokeTheBank || (XwaysHoarder2.model.gameData.brokeTheBank && XwaysHoarder2.apiPlugin.gameClientConfiguration.displayIndividualWinsInGame)){
                                winTl.add(() => {
                                    XwaysHoarder2.winView.playWinNumbers(groupWin, false, winNumPlayPosition);
                                }, delay * offset);
                            }
                        }
                    }
                });
            });
        }

        return winTl;
    }

    private getInitialWin(isBigWin: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const winSymbols = SymbolUtils.getAllSymbolsWithStateByReel(SymbolStates.WIN);
        const winSymbolsList = SymbolUtils.getAllSymbolsWithState(SymbolStates.WIN);
        const noWinSymbols = SymbolUtils.getAllSymbolsWithState(SymbolStates.NO_WIN);

        tl.add(XwaysHoarder2.reelView.showReelsNoWinOverlay(),0);
        tl.add(SymbolUtils.getSymbolStateAnimations(noWinSymbols, SymbolStates.NO_WIN), 0);

        for (let reel of winSymbols) {
            //Reverse to add the symbols bottom to top.
            tl.add(SymbolUtils.getSymbolStateAnimations(reel.reverse(), SymbolStates.WIN), "<0.05");
        }

        if (isBigWin || XwaysHoarder2.model.data.brokeTheBank) {
            //tl.add(SymbolUtils.getSymbolShakeAnimations(winSymbolsList, 0.938));
            tl.add(() => {
                XwaysHoarder2Sound.fadeMusic(0, 20);
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BIGWIN_INTRO);
            }, "<");
        }

        return tl;
    }


}